import { TemplateRef } from '@angular/core';

export class OverlayContent {

  constructor(public content: TemplateRef<any> | string) {}

}
